import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 评分记录 (ExamScoreRecord) — 只读, 评分员实际打分通过专门 UI 完成.
 */
export const scoringConfig: CrudConfig = {
  resource: 'scoring',
  title: '评分记录',
  rowKey: 'id',
  searchFields: ['status', 'is_payment_eligible'],
  disableCreate: true,
  disableEdit: true,
  disableDelete: true,
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, readonly: true },
    { name: 'answer_sheet_uuid', label: '答卷 UUID', type: 'text', copyable: true, width: 260, readonly: true, ellipsis: true },
    { name: 'scorer_email', label: '评分员', type: 'readonly', width: 200, ellipsis: true, readonly: true },
    {
      name: 'status',
      label: '状态',
      type: 'select',
      width: 120,
      readonly: true,
      options: [
        { label: '待领取', value: 'PENDING', status: 'Default' },
        { label: '评分中', value: 'SCORING', status: 'Processing', color: 'blue' },
        { label: '已完成', value: 'COMPLETED', status: 'Success', color: 'green' },
        { label: '已过期', value: 'EXPIRED', status: 'Warning', color: 'orange' },
        { label: '已取消', value: 'CANCELLED', status: 'Error', color: 'red' },
      ],
    },
    { name: 'total_score', label: '总分', type: 'number', width: 90, readonly: true },
    { name: 'is_payment_eligible', label: '可结算', type: 'boolean', width: 100, readonly: true },
    { name: 'locked_until', label: '锁定截止', type: 'datetime', width: 180, readonly: true, hideInTable: true },
    { name: 'created_at', label: '创建时间', type: 'datetime', width: 180, readonly: true },
    { name: 'completed_at', label: '完成时间', type: 'datetime', width: 180, readonly: true, hideInTable: true },
  ],
};
